// extracted by mini-css-extract-plugin
module.exports = {"block":"style_block__Ie2lE","item":"style_item__IOHps","seriesImg":"style_seriesImg__WP_gC"};